// extracted by mini-css-extract-plugin
module.exports = {"player_container":"VideoCard_player_container__1zLYY","play_btn":"VideoCard_play_btn__3hX9Y","play_btn_icon":"VideoCard_play_btn_icon__lbRJz"};